import { render, staticRenderFns } from "./creator-info.vue?vue&type=template&id=c8468a8a&"
import script from "./creator-info.vue?vue&type=script&lang=js&"
export * from "./creator-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports